import script from "./CommentLast.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentLast.vue?vue&type=script&setup=true&lang=js"

import "./CommentLast.vue?vue&type=style&index=0&id=7ea6280c&lang=scss"

const __exports__ = script;

export default __exports__